import ConsumableForm, {
  ConsumableFormData,
} from '@/components/Operational/Inventory/Consumables/ConsumableForm';

import { getImgUrl } from '@/core/domain/archive/Archive/Archive.utils';
import { useCreateConsumable } from '@/core/domain/operational/Consumables/Consumables.hooks';
import { CreateConsumableRequest } from '@/core/domain/operational/Consumables/Consumables.types';
import { Form, Modal, ModalProps } from 'antd';
import React from 'react';

interface Props extends ModalProps {
  onCancel: () => void;
}

const ConsumablesSimpliedRegisterModal = ({ ...props }: Props) => {
  const [form] = Form.useForm<ConsumableFormData>();

  const createMutation = useCreateConsumable();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreateConsumableRequest = {
        ...values,
        imageUrl: values.imageUrl ? getImgUrl(values.imageUrl[0]) : undefined,
      };

      await createMutation.mutateAsync(obj);

      props.onCancel();
    } catch {}
  };

  return (
    <Modal
      title="Cadastro de insumo"
      width="90%"
      {...props}
      okText="Cadastrar"
      onOk={handleOk}
      destroyOnClose
      confirmLoading={createMutation.isLoading}
    >
      <ConsumableForm form={form} isLoading={false} />
    </Modal>
  );
};

export default ConsumablesSimpliedRegisterModal;
